<template>
  <div class="barra-filtros-ativos d-flex align-items-center flex-wrap gap-1 px-3 py-1">
    <span class="barra-label small fw-semibold me-1">Filtros:</span>

    <span
      v-for="badge in badges"
      :key="badge.id"
      class="badge barra-badge d-inline-flex align-items-center gap-1 px-2 py-1"
      :title="badge.tooltip"
    >
      <i :class="badge.icone || 'bi bi-funnel'" class="small"></i>
      {{ badge.rotulo }}
      <button class="btn-close btn-close-sm ms-1 barra-close" style="font-size: 0.5rem;" @click="$emit('remover-filtro', badge.chave, badge.id)"></button>
    </span>

    <button
      v-if="badges.length > 0"
      class="btn btn-link btn-sm text-decoration-none barra-limpar ms-1 p-0"
      @click="$emit('limpar-todos')"
    >
      <i class="bi bi-x-circle me-1"></i>Limpar todos
    </button>

    <span v-if="badges.length === 0" class="barra-vazia small">Nenhum filtro aplicado</span>

    <span class="ms-auto barra-subtitulo small">
      <i class="bi bi-info-circle me-1"></i>{{ subtitulo }}
    </span>
  </div>
</template>

<script setup>
defineProps({
  badges: { type: Array, default: () => [] },
  subtitulo: { type: String, default: '' }
})

defineEmits(['remover-filtro', 'limpar-todos'])
</script>

<style scoped>
.barra-filtros-ativos {
  --barra-bg: var(--bs-tertiary-bg);
  --barra-border: var(--bs-border-color);
  --barra-badge-bg: rgba(13, 110, 253, 0.1);
  --barra-badge-color: var(--bs-primary);
  --barra-badge-border: var(--bs-primary);
  --barra-text-muted: var(--bs-secondary-color);
  min-height: 32px;
  font-size: 0.8rem;
  background: var(--barra-bg);
  border-bottom: 1px solid var(--barra-border);
}

.barra-label {
  color: var(--barra-text-muted);
}

.barra-badge {
  background: var(--barra-badge-bg);
  color: var(--barra-badge-color);
  border: 1px solid var(--barra-badge-border);
}

.barra-close {
  color: var(--barra-badge-color);
}

.barra-limpar {
  color: var(--bs-danger) !important;
  font-size: 0.8rem;
}

.barra-vazia {
  color: var(--barra-text-muted);
}

.barra-subtitulo {
  color: var(--barra-text-muted);
}
</style>
